import script from "./EditPromotion.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditPromotion.vue?vue&type=script&lang=ts&setup=true"

import "./EditPromotion.vue?vue&type=style&index=0&id=ad358d32&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad358d32"]])

export default __exports__